import {VehicleOwnershipEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function driverVehicleOwnershipNameFilter(type: VehicleOwnershipEnum) {
  switch(type) {
    case VehicleOwnershipEnum.OwnedOrRented: return i18n.t(LF.HasOwnTransport) as string;
    case VehicleOwnershipEnum.RentedFromCarrier: return i18n.t(LF.WantToRentFromCarrier) as string;
    case VehicleOwnershipEnum.OwnedByCarrier: return i18n.t(LF.WantToWorkOnFleetCar) as string;
  }
}
